// extracted by mini-css-extract-plugin
export var alpha = "_kv-4";
export var alphaInputContainer = "_kv-j";
export var badge = "_kv-b";
export var brandKitGrid = "_kv-l";
export var brandKitItem = "_kv-m";
export var brandKitSwatch = "_kv-n";
export var controls = "_kv-5";
export var formatDropdown = "_kv-h";
export var formatSelector = "_kv-g";
export var hex = "_kv-6";
export var hexInput = "_kv-i";
export var hue = "_kv-3";
export var hueAndAlphaPointer = "_kv-a";
export var percentageLabel = "_kv-k";
export var picker = "_kv-0";
export var rgba = "_kv-8";
export var rgbaSection = "_kv-7";
export var saturation = "_kv-1";
export var saturationPointer = "_kv-9";
export var sliders = "_kv-2";
export var swatch = "_kv-c";
export var swatchDisabled = "_kv-f";
export var swatchRing = "_kv-d";
export var swatchTransparent = "_kv-e";